<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex xs6>
          <h6>Transfer Ticket</h6>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn fab small flat @click="handleCancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div class="mb-4">
            <strong>{{ $t('select_agent_to_transfer') }}</strong>
          </div>
          <template v-if="!loadingAgent">
            <div class="form-control mb-3" :class="{ 'has-error': errors.has('group') }">
              <div class="caption mb-1">Group <span class="red--text">*</span></div>
              <multiselect
                v-model="input.group"
                v-validate="'required'"
                :options="agentGroup"
                track-by="groupname"
                label="groupname"
                :searchable="true"
                select-label
                selected-label
                deselect-label
                name="group"
                data-vv-as="Group"
                @input="
                  input.subgroup = ''
                  input.agent = ''
                "
              ></multiselect>
              <span v-if="errors.has('group')" class="text-error">{{ errors.first('group') }}</span>
            </div>
            <div class="form-control mb-3" :class="{ 'has-error': errors.has('subgroup') }">
              <div class="caption mb-1">SubGroup</div>
              <multiselect
                v-model="input.subgroup"
                :disabled="!input.group"
                :options="filterSubGroup"
                track-by="subgroupname"
                label="subgroupname"
                :searchable="true"
                select-label
                selected-label
                deselect-label
                name="subgroup"
                @input="input.agent = ''"
              ></multiselect>
              <span v-if="errors.has('subgroup')" class="text-error">{{
                errors.first('subgroup')
              }}</span>
            </div>
            <div class="form-control mb-3" :class="{ 'has-error': errors.has('agent') }">
              <div class="caption mb-1">Agent <span class="red--text">*</span></div>
              <multiselect
                v-model="input.agent"
                v-validate="'required'"
                :disabled="!input.group"
                :options="filterAgents"
                :searchable="true"
                name="agent"
                select-label
                selected-label
                deselect-label
                data-vv-as="Agent"
              ></multiselect>
              <span v-if="errors.has('agent')" class="text-error">{{ errors.first('agent') }}</span>
            </div>
            <div class="text-xs-center">
              <v-btn depressed color="primary" @click="handleSubmit">
                {{ $t('Transfer') }}
              </v-btn>
              <v-btn color="grey" outline @click="handleCancel">
                {{ $t('cancel') }}
              </v-btn>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      input: {
        group: '',
        subgroup: '',
        agent: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    filterSubGroup() {
      if (this.input.group && this.agentSubGroup) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.input.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      let agents = []
      if (this.input.group) {
        agents = this.agents.filter((el) => {
          return el.admingroupid == this.input.group.id
        })

        if (this.input.subgroup) {
          agents = this.agents.filter((el) => {
            return el.adminsubgroupid == this.input.subgroup.id
          })
        }
      } else {
        agents = this.agents
      }

      return agents.length > 0 ? agents.map((el) => el.adminid) : []
    }
  },
  async mounted() {
    if (this.agentGroup && this.agentGroup.length === 0) {
      await this.$store.dispatch('loadAgentGroups')
    }
    if (this.agentSubGroup && this.agentSubGroup.length === 0) {
      await this.$store.dispatch('loadAgentSubGroups')
    }
    if (this.agents && this.agents.length === 0) {
      await this.$store.dispatch('loadAgents')
    }
  },
  methods: {
    async handleSubmit() {
      const vm = this
      const isValid = await vm.$validator.validate()

      if (!isValid) {
        return false
      }

      vm.$emit('selectedAgent', vm.input)
      vm.$emit('close')
    },
    handleCancel() {
      this.input = {
        group: '',
        subgroup: '',
        agent: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/DialogSelectAgent.vue